import React, { useState, useEffect } from 'react';
import "../CSS/SoftWares.css";
import spic3 from "../Images/spic3.png"
import spic4A from "../Images/spic4A.png";
import spic4B from "../Images/spic4B.png";
import spic5A from "../Images/spic5A.png";
import spic5B from "../Images/spic5B.png";
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const softwareData = [
  {
    id: 1,
    images: [spic4A, spic4B],
    title: "AUTODESK CIVIL 3D",
    descriptions: [
      "70,500sqm Site Development For A Factory (Raw Data From Site Survey) ",
      "(After Site Grading) "
    ],
    description2: "This is a 3d software for modelling and designing all kinds of horizontal structures such as Road, Railway, Water Way, Pipeline, Drainage, Canal etc."
  },
  {
    id: 2,
    images: [spic5A, spic5B],
    title: "AUTODESK REVIT",
    descriptions: [
      "Tile Factory of 100m by 460m Warehouse, With Utilities, Offices and Residential Facility Cited on 17Hectares of Land.",
      "As built Model for Renovation and Fabrication using Scan To BIM Process"
    ],
    description2: "This is a 3d software for modelling all types of building, external and internal features, plumbing and piping works. Well integrated to have a complete working model. And also used to generate working drawings for planning approvals and construction drawings. "
  },
];


const softwareData2 = [
  { id: 3, image: spic3, url:"",title: "ROBOT STRUCTURAL ANALYSIS", description1: "Design Of 80m X 45m Warehouse Building With 20m Width Loading Bay", description2: "This is a 3d software for concrete and steel analysis and design, optimize steel member, foundation sizing. " },
]

const CarouselSoftWares = () => {
  const [expandedCard, setExpandedCard] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
  //   }, 3000);

  //   return () => clearInterval(interval);
  // }, []);

  const handleLeft =()=>{
    setCurrentImageIndex((currentImageIndex-1+2)%2)
  }

  const handleRight =()=>{
    // setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
    setCurrentImageIndex((currentImageIndex+1)%2)
  }

  const toggleExpand = (id) => {
    setExpandedCard(expandedCard === id ? null : id);
  };

  return (
    <div className='SoftwareContainerWrap'>
      {/* <h1>SOME OF THE APPS I DEPLOYED ON SOME PROJECTS</h1> */}
      <div className="software-container">
        {softwareData.map((software) => (
          <div className="software-card" key={software.id} >
            <img
              src={software.images[currentImageIndex]}
              alt={software.title}
              className="software-image"
            />
            <FaArrowLeft className='Arrow' style={{left:0}} onClick={handleLeft}/>
            <FaArrowRight className='Arrow' style={{right:0}} onClick={handleRight}/>
            <p
              style={{
                color: "rgba(0,0,255,0.7)",
                fontStyle: "italic",
                fontWeight: "500",
                // position:"absolute",
                // top:"50px",
                // width:"70%",
                textAlign:"center",
                // left:"25%",
                // backgroundColor:"rgba(0,0,0,0.5)",
                // padding:"10px",
                // borderRadius:"10px",
                // color:"white"
              }}
            >
              {software.descriptions[currentImageIndex]}
            </p>
            <h3 style={{ color: "blue" }}>{software.title}</h3>
            <p className="expanded">
              {software.description2}
            </p>
           
          </div>
        ))}

{softwareData2.map((software) => (
          <div className="software-card" key={software.id} >
            <img
              src={software.image}
              alt={software.title}
              className="software-image"
            />
            <p
              style={{
                color: "rgba(0,0,255,0.7)",
                fontStyle: "italic",
                fontWeight: "500",
                // position:"absolute",
                // top:"50px",
                // width:"50%",
                textAlign:"center",
                // left:"25%",
                // backgroundColor:"rgba(0,0,0,0.5)",
                // padding:"10px",
                // borderRadius:"10px",
                // color:"white"
              }}
            >
              {software.description1}
            </p>
            <h3 style={{ color: "blue" }}>{software.title}</h3>
            <p className="expanded">
              {software.description2}
            </p>
           
          </div>
        ))}

      </div>
    </div>
  );
};

export default CarouselSoftWares;
